import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { ReportTemplateList } from '@futrli-sdk/predict';

import { DuplicateTemplateWizardContainer } from './duplicate-template-wizard-container';

interface DuplicateTemplateSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  template: ReportTemplateList;
}

export const DuplicateTemplateSidebar = ({ isOpen, onClose, template }: DuplicateTemplateSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="reporting.duplicate_template" defaultMessage="Duplicate template" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <DuplicateTemplateWizardContainer onClose={onClose} template={template} />
  </Sidebar>
);
